import { render } from "./ContactInformationsComponent.vue?vue&type=template&id=f498dfae"
import script from "./ContactInformationsComponent.vue?vue&type=script&lang=js"
export * from "./ContactInformationsComponent.vue?vue&type=script&lang=js"

import "./ContactInformationsComponent.vue?vue&type=style&index=0&id=f498dfae&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__